import { QueryCard } from '@sparkpost/matchbox';

export default QueryCard;
